import { Collapse } from "antd"
import type { SizeType } from "antd/es/config-provider/SizeContext"
import type { CollapseProps } from "antd"
import { ChevronIcon } from "components/ui/customWebviewer/ElevationReferencesSidebar/icons/ChevronIcon"

type Props = {
	items: CollapseProps["items"]
	bordered?: boolean
	size?: SizeType
	ghost?: boolean
	defaultActiveKey?: string | number | (string | number)[] | undefined
	activeKey?: CollapseProps["activeKey"]
	onChange?: CollapseProps["onChange"]
	className?: string
	destroyOnHidden?: boolean
	expandIcon?: CollapseProps["expandIcon"]
}

export const CollapseElevations = ({
	items,
	bordered = false,
	size = "large",
	ghost = true,
	defaultActiveKey,
	activeKey,
	onChange,
	className = "",
	destroyOnHidden = true,
	expandIcon = ({ isActive }) => <ChevronIcon isActive={isActive} />,
}: Props) => {
	return (
		<Collapse
			items={items}
			bordered={bordered}
			size={size}
			ghost={ghost}
			defaultActiveKey={defaultActiveKey}
			activeKey={activeKey}
			onChange={onChange}
			className={className}
			destroyOnHidden={destroyOnHidden}
			expandIcon={expandIcon}
		/>
	)
}
